export const SET_PRODUCT_FILTERS = 'PRODUCTS/SET_PRODUCT_FILTERS';
export const SET_PRODUCT_LIST = 'PRODUCTS/SET_PRODUCT_LIST';
export const SET_PRODUCT_LIST_LOADING = 'PRODUCTS/SET_PRODUCT_LIST_LOADING';
export const SET_IS_CONSUME_LIST = 'PRODUCTS/SET_IS_CONSUME_LIST';
export const SET_IS_SELL_LIST = 'PRODUCTS/SET_IS_SELL_LIST';